
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.02 4.034V.045H.063v17.951h17.914V4.034zM3.646 16.002H1.855v-1.995h1.791zm0-3.99H1.855v-1.994h1.791zm0-3.989H1.855V6.03h1.791zm0-3.989H1.855V2.04h1.791zm3.583 11.968H5.437v-1.995H7.23zm0-3.99H5.437v-1.994H7.23zm0-3.989H5.437V6.03H7.23zm0-3.989H5.437V2.04H7.23zm8.957 11.968H9.02v-1.995h1.792v-1.995H9.02v-1.994h1.792V8.023H9.02V6.03h7.166zm-1.792-7.979h-1.791v1.995h1.791zm0 3.99h-1.791v1.994h1.791z"}})])
          )
        }
      }
    